import React, { useCallback } from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { Box, Grow, List, MenuItem, Paper } from '@material-ui/core'

import column from '../assets/column.svg'

import { MyProductsColumnItem } from './MyProductsColumnItem'
import { ProperClickAwayListener } from './ProperClickAwayListener'

import { useStore } from '../hooks/storeHook'
import { useBoolState } from '../hooks/commonHooks'
import { useMyProductColumns } from '../hooks/myProductHooks'
import { useDefaultMenuItemStyles } from '../hooks/defaultSelectStylesHook'

import { keysOf } from '../common/tsUtils'

export const MyProductsColumnsMenu =
  observer(() => {
    const classes = useDefaultMenuItemStyles()

    const {hiddenMyProductColumnIds} = useStore()
    const myProductColumns = useMyProductColumns()

    const [isOpen, /*setOpen*/, setClosed, toggleOpen] = useBoolState()

    const handleToggle =
      useCallback((e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()

        toggleOpen()
      }, [toggleOpen])

    return (
      <Box position="relative">
        <button
          className={clsx('btn', {'btn_isactive': hiddenMyProductColumnIds.size > 0})}
          onClick={handleToggle}
        >
          <p>Столбцы</p>
          <img src={column} alt={'Столбцы'}/>
        </button>

        {
          isOpen &&
          <ProperClickAwayListener isOpen={isOpen} onClose={setClosed}>
            <Grow in={isOpen} style={{transformOrigin: 'top'}}>
              <Paper className={classes.menu} style={{position: 'absolute', zIndex: 1, minHeight: '400px'}}>
                <List component="nav">
                  {
                    keysOf(myProductColumns.grouped).map(groupId => (
                      !!myProductColumns.grouped[groupId].length &&
                      <MenuItem
                        key={groupId}
                        className={classes.menuItem}
                        component="div"
                        button={false}
                        style={{fontSize: '12px !important'}}
                      >
                        <MyProductsColumnItem groupId={groupId}/>
                      </MenuItem>))
                  }
                </List>
              </Paper>
            </Grow>
          </ProperClickAwayListener>
        }
      </Box>
    )
  })